import React from "react";
import { FormGroup, Col, Row, Container, Button } from "react-bootstrap";
import { connect } from "react-redux";

import styles from "./resetPasswordLinkError.module.scss";

class ResetPasswordLinkErrorPage extends React.Component {
	constructor(props) {
		super(props);
		if (!this.props.showResetPasswordLinkErrorPage) {
			this.props.history.push("/");
		}
		this.okClick = this.okClick.bind(this);
	}

	okClick() {
		this.props.history.push("/");
	}

	render() {
		return (
			<Container>
				<Row className={styles.login}>
					<Col
						className={styles.loginBlock + " align-self-center"}
						md={{ span: 8, offset: 2 }}
					>
						<Col md={{ span: 8, offset: 2 }}>
							<div className={styles.welcomBlock}>
								<span className={styles.messageBlock}>
									<h2>
										<b>YOUR LINK IS EXPIRED</b>
									</h2>
									<div>You should use the latest.</div>
								</span>
							</div>
							<FormGroup className="text-center">
								<Button
									onClick={this.okClick}
									className={styles.okBtn}
								>
									OK
								</Button>
							</FormGroup>
						</Col>
					</Col>
				</Row>
			</Container>
		);
	}
}

function mapStateToProps(state) {
	return {
		showResetPasswordLinkErrorPage:
			state.user.showResetPasswordLinkErrorPage,
	};
}

const connectedCodeFailurePage = connect(mapStateToProps)(
	ResetPasswordLinkErrorPage,
);
export { connectedCodeFailurePage as ResetPasswordLinkErrorPage };
